import Styles from './styles.module.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Item from './1.item/index';
import { collection, getFirestore, onSnapshot, query, where } from 'firebase/firestore';
import GraduationMake, { GraduationEditing } from './2.make/index';
import { useAppSelector } from 'src/salon/app/hook';

type SchoolEditGraduationProps = {
  make: boolean;
  setMake: React.Dispatch<React.SetStateAction<boolean>>;
};

// makeはシェル(desktop/index.tsx)のヘッダーボタンから開閉される(他ページの追加ボタンと表示位置を統一するため)
const SchoolEditGraduation: React.FC<SchoolEditGraduationProps> = ({ make, setMake }) => {

  const company = useAppSelector((state) => state.company.company);

  const [ checklist, setCheckList ] = useState<string[]>([]);
  const [ schoolList, setSchoolList ] = useState<any[]>([]);
  // 「編集する」で開いている卒業生
  const [ editing, setEditing ] = useState<GraduationEditing | null>(null);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    const db = getFirestore();
    const queryRef = query(
      collection(db, '/graduation'),
      where('companyId', '==', company.id)
    );

    const unsub = onSnapshot(queryRef, (snapshot) => {
      const tmp: any[] = snapshot.docs.map((doc) => ({
        id: doc.id,
        name: doc.data().name,
        school: doc.data().school,
        graduation_years: doc.data().graduation_years,
        postion: doc.data().postion,
      }));
      setSchoolList(tmp);
    });
    
    return () => unsub();
  }, [ company.id ]);

  return (
    <>
    <div className={Styles.box}>

      <div>

        <div className={Styles.recruit_title}>
          <button onClick={() => setMake(true)}>＋ 卒業生を追加する</button>
        </div>

        <div className={Styles.recruit_table}>
          <div className={Styles.recruit_table_nav}>
            <h3 className={Styles.recruit_table_nav_2}>氏名</h3>
            <h3 className={Styles.recruit_table_nav_3}>出身学校</h3>
            <h3 className={Styles.recruit_table_nav_4}>卒業年度</h3>
            <h3 className={Styles.recruit_table_nav_role}>役職</h3>
          </div>

          {schoolList.map((data, index) => (
            <div key={index}>
              <Item school={data} checklist={checklist} setCheckList={setCheckList} onEdit={() => setEditing(data)} />
            </div>
          ))}
        </div>

      </div>

    </div>

    {make ? <GraduationMake setMake={setMake} companyId={company.id} /> : <></> }
    {editing && <GraduationMake key={editing.id} setMake={() => setEditing(null)} companyId={company.id} editing={editing} />}
    </>
  );
}

export default SchoolEditGraduation;
